<script>
import Masonry from 'masonry-layout';
import FormFetch from './components/form-fetch';
import { gmapsMap, gmapsMarker } from 'x5-gmaps';
import FeaturePosts from './components/feature-posts';
import FeatureEvents from './components/feature-events';
import DirectionalHover from './components/directional-hover';
import FeaturePostsItem from './components/feature-posts-item';

export default {
	components: {
		gmapsMap,
		FormFetch,
		gmapsMarker,
		FeaturePosts,
		FeatureEvents,
		FeaturePostsItem,
		DirectionalHover,
	},
	data() {
		return {
			searchActive: false,
			navActive: false,
			navSubmenuActive: [],
			sidebarOffsetTop: 0,
		};
	},
	computed: {
		relativeUrl() {
			return window.location.pathname + window.location.search;
		},
		isNavSubmenuActive() {
			return ( val ) => this.navSubmenuActive.includes( val );
		},
	},
	watch: {
		searchActive( val ) {
			if ( val === true ) {
				if ( this.navActive ) {
					this.navActive = false;
				}
				this.$refs.search.focus();
			}
		},
		navActive( val ) {
			if ( val === true ) {
				if ( this.searchActive ) {
					this.searchActive = false;
				}
			}
		},
	},
	mounted() {
		document.addEventListener( 'keydown', ( e ) => {
			if ( e.key === 'Escape' ) {
				this.searchActive = false;
			}
		} );
		const grid = document.querySelector( '.masonrish' );
		if ( grid ) {
			const msnry = new Masonry( grid, {
				// options...
				itemSelector: '.masonrish__item',

				horizontalOrder: true,
			} );
			Array.from( grid.querySelectorAll( 'img' ), ( img ) => img.addEventListener( 'load', () => msnry.layout() ) );
		}
	},
	methods: {
		setNavSubmenuActive( val ) {
			if ( this.navSubmenuActive.includes( val ) ) {
				this.navSubmenuActive = this.navSubmenuActive.filter( ( el ) => el !== val );
			} else {
				this.navSubmenuActive.push( val );
			}
		},
		sidebarSelectChange( e ) {
			window.location = e.target.value;
		},
		setLocationEmpty() {
			window.location = location.href.split( '?' )[ 0 ];
		},
	},
};
</script>

<style src="./styles/utilities.css"></style>
